/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrossCompanyMoveFolderContentsCto } from '../../models/cross-company-move-folder-contents-cto';
import { CrossCompanyMoveFolderContentsResultCto } from '../../models/cross-company-move-folder-contents-result-cto';

export interface MoveFolderContents$Plain$Params {
      body?: CrossCompanyMoveFolderContentsCto
}

export function moveFolderContents$Plain(http: HttpClient, rootUrl: string, params?: MoveFolderContents$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CrossCompanyMoveFolderContentsResultCto>> {
  const rb = new RequestBuilder(rootUrl, moveFolderContents$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CrossCompanyMoveFolderContentsResultCto>;
    })
  );
}

moveFolderContents$Plain.PATH = '/crosscompanyfolder/movefoldercontents';
